// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"aef8eab2","513":"df3d82c9","703":"9718fc73","787":"0a01d9fa"}[chunkId] + ".chunk.js";
};